import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=0f1b0d7c&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"
import style0 from "./Provider.vue?vue&type=style&index=0&id=0f1b0d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b0d7c",
  null
  
)

export default component.exports